module.exports = __webpack_public_path__ + "static/media/mckinsey_logo.f6f0eba5.png";